module.exports = __webpack_public_path__ + "img/s_blackblackT-logo.b2c9971.png";